<script setup>
import { ref, computed, onMounted, onUnmounted } from 'vue';
import { useRoute } from 'vue-router';
import WebAppIframe from './components/WebAppIframe.vue';
import AppChrome from './components/nav/AppChrome.vue';
import AppSplash from './components/app/AppSplash.vue';
import { updateServiceWorker } from '@/utils/app/registerServiceWorker';
import { useTranslator } from '@/composables/useTranslator';
import { eventBus } from '@/utils/core/eventBus';
import { useAppChrome } from '@/composables/useAppChrome';
import { session } from '@/utils/auth/sessionService';
const t = useTranslator();
const route = useRoute();
const isLegacyRoute = computed(() => Boolean(route.meta?.legacyView));
const { visible: chromeVisible, desktop, nav } = useAppChrome();
const hasTopBar = computed(() => chromeVisible.value && desktop.value);
const iframeVisible = computed(() => isLegacyRoute.value && nav.page === 'app');
const showSplash = computed(() => session.status === 'pending' || !route.matched.length || (isLegacyRoute.value && !iframeVisible.value));
const showUpdateSnackbar = ref(false);
let pendingUpdate = false;
let externisReady = false;

function onUpdateAvailable() {
	if (externisReady) {
		// showUpdateSnackbar.value = true;
	} else {
		pendingUpdate = true;
	}
}

function onExternisReady() {
	externisReady = true;
	if (pendingUpdate) {
		// showUpdateSnackbar.value = true;
		pendingUpdate = false;
	}
}

function confirmUpdate() {
	showUpdateSnackbar.value = false;
	updateServiceWorker();
}

onMounted(() => {
	window.addEventListener('sw-update-available', onUpdateAvailable);
	eventBus.on('externis-ready', onExternisReady);
});

onUnmounted(() => {
	window.removeEventListener('sw-update-available', onUpdateAvailable);
	eventBus.off('externis-ready', onExternisReady);
});
</script>

<template>
	<v-app class="app-shell">
		<AppChrome />
		<v-main class="app-shell__main">
			<WebAppIframe :visible="iframeVisible" :safe-top="!hasTopBar" />
			<router-view />
			<AppSplash v-if="showSplash" />
		</v-main>
		<v-snackbar v-model="showUpdateSnackbar" :timeout="-1" location="bottom" rounded="xl">
			{{ t('New version available. Please refresh the page.') }}
			<template #actions>
				<v-btn variant="text" @click="showUpdateSnackbar = false">{{ t('Close') }}</v-btn>
				<v-btn color="primary" variant="text" @click="confirmUpdate">{{ t('Update') }}</v-btn>
			</template>
		</v-snackbar>
	</v-app>
</template>
